import { createSelector } from "reselect";

const currentPackageSelector = state => state.entities.packageInformation && Object.values(state.entities.packageInformation)[0];
const subscriptionSelector = state => state?.subscription?.stripe_sub|| {} ;
const userPackageInfoSelector = state => state?.subscription?.UserPackageInfo|| {} ;

const subscriptionInfoSelector = createSelector(currentPackageSelector, subscriptionSelector,userPackageInfoSelector,
    (packageInfo, subscriptionInfo, userPackageInfo)=> {
        console.log(" +++++ packageInfos++", packageInfo);
        const { id, brandLimit,socialAccLimit, maxStorageSize,userLimit,acOnEachPlatform} = packageInfo||{};
        
        const { brand_units, social_account_units, storage_units, user_units} = subscriptionInfo||{};

        return {
            ...subscriptionInfo,
            ...packageInfo,
            packageId: id,
            brandLimit: Number(brandLimit) + Number(brand_units),
            socialAccountLimit: Number(socialAccLimit)+Number(social_account_units),
            storageLimit:Number(maxStorageSize)+Number(storage_units),
            userLimit: Number(userLimit)+Number(user_units),
            accOnEachPlatformLimit:Number(acOnEachPlatform),
            userPackageInfo,
        }
    })

export {subscriptionInfoSelector};